import IconBox from "./IconBox";
import { IconContainer } from "./styles";
import { InlineIconConfig } from "./DefaultConfig";
import { withInlineVoidElement } from "../../utils";
import type { ViewerDeviceRuntime } from "../../../../../types";
import { resolveInlineIconMetadata } from "./utils";

export type InlineIconPluginOptions = {
  pluginConfigs?: Record<string, InlineIconConfig>;
  viewerDevice?: ViewerDeviceRuntime;
};

export default function InlineIconOffline(options: InlineIconPluginOptions = {}) {
  const { pluginConfigs, viewerDevice } = options;

  const plugin = (editor: any) => {
    withInlineVoidElement(editor, "inline-icon");
    return editor;
  };

  plugin.renderElement = ({ element, attributes, children }: any) => {
    if (element.type !== "inline-icon") {
      return undefined;
    }

    const metadata = resolveInlineIconMetadata(element.data, pluginConfigs);

    if (!metadata?.url) {
      return <span {...attributes} aria-hidden="true" />;
    }

    return (
      <IconContainer {...attributes} className="spf-inline-icon" contentEditable={false}>
        <IconBox metadata={metadata} viewerDevice={viewerDevice} />
        {children}
      </IconContainer>
    );
  };

  return plugin;
}
